import { Address } from "@api/models/Address";

export class WetInkData {
  wetInkRequested: boolean = false
  wetInkRecipientAddress: Address = new Address
  wetInkPartnerComment?: string
  wetInkDeliveryInfo?: string
}
